import { Button } from '@safetyhub/ui';

interface StepFooterProps {
  onCancel?: () => void;
  cancelDisabled?: boolean;
  onBack?: () => void;
  backDisabled?: boolean;
  onNext?: () => void;
  nextType?: 'button' | 'submit';
  /**
   * `nextType='submit'`일 때 제출할 폼의 `id`(HTML5 `form` 속성).
   *
   * ⛔ **`<Modal footer={…}>`에서는 «필수»다.** base Modal이 본문과 푸터를 **형제 div**로
   * 렌더하므로 이 푸터는 children의 `<form>` 밖이고, 그 연결이 없으면 제출이 **조용히** 일어나지
   * 않는다(버튼은 멀쩡하고 tsc·spec 어느 것도 못 본다).
   */
  nextForm?: string;
  nextDisabled?: boolean;
  nextLabel?: string;
  cancelLabel?: string;
  backLabel?: string;
}

/**
 * 현장 생성 스텝 푸터 — 취소/이전/다음.
 *
 * base Modal의 `footer` prop에 그대로 넘기도록 **fragment만** 낸다(구분선·간격·고정 배치는
 * base가 소유한다). 종전에는 web 어댑터의 푸터 래퍼로 감싸 children 안에 놓였고, 그러면 긴
 * 본문에서 버튼이 함께 스크롤됐다 — 그 경위는 `components/Modal.tsx`의 그 자리 주석.
 */
export function StepFooter({
  onCancel,
  cancelDisabled,
  onBack,
  backDisabled,
  onNext,
  nextType = 'button',
  nextForm,
  nextDisabled,
  nextLabel = '다음 →',
  cancelLabel = '취소',
  backLabel = '← 이전',
}: StepFooterProps) {
  return (
    <>
      {onCancel && (
        <Button variant="secondary" onClick={onCancel} disabled={cancelDisabled}>
          {cancelLabel}
        </Button>
      )}
      {onBack && (
        <Button variant="secondary" onClick={onBack} disabled={backDisabled}>
          {backLabel}
        </Button>
      )}
      <Button
        variant="primary"
        type={nextType}
        form={nextType === 'submit' ? nextForm : undefined}
        onClick={nextType === 'submit' ? undefined : onNext}
        disabled={nextDisabled}
      >
        {nextLabel}
      </Button>
    </>
  );
}
